import React, { useMemo, memo, useContext } from "react";
import {NavLink} from "react-router-dom";
import { StyledTopbar, StyledTrialDaysCounter } from "./topbar.style";
import UserProfileCorner from "../../auth/userProfile/UserProfileCorner.component";
import StateContext from "../../../context/StateContext";
import {StyledList, StyledNavbar} from "../navbar.style";

const TrialDaysCounter = ({ days }) => {
	if (days > 0) {
		return <StyledTrialDaysCounter key="trialDaysCounter">{`Your Fixel trial expires in ${days} ${days > 1 ? "days" : "day"}`}</StyledTrialDaysCounter>;
	} else if (days <= 0) {
		return <StyledTrialDaysCounter key="trialDaysCounter">Your Fixel trial has expired</StyledTrialDaysCounter>;
	}
	return null;
};

const TopBar = () => {
	const { segMap, selectedSegmentCode, plansMap, user } = useContext(StateContext);
	const trial_days_remaining = useMemo(
		() =>
			selectedSegmentCode && segMap && segMap[selectedSegmentCode] && plansMap && plansMap[segMap[selectedSegmentCode]?.plan_id]
				? plansMap[segMap[selectedSegmentCode]?.plan_id]?.trial_days_remaining
				: null,
		[plansMap, segMap, selectedSegmentCode]
	);

	return (
		<StyledNavbar>
			<StyledTopbar>
				<StyledList>
					<li key="dashboard">
						<NavLink to="/dashboard">Dashboard</NavLink>
					</li>
					<li key="plans">
						<NavLink to="/plans">Plans</NavLink>
					</li>
					<li key="setup">
						<NavLink to={`/segments/edit/${selectedSegmentCode}`}>Settings</NavLink>
					</li>
					<li key="support">
						<NavLink to="/support">Support</NavLink>
					</li>
				</StyledList>
				<TrialDaysCounter days={trial_days_remaining} />
				<UserProfileCorner mail={user?.email}></UserProfileCorner>
			</StyledTopbar>
		</StyledNavbar>
	);
};
export default memo(TopBar);
